document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("/blogs/")) return;

  const blogContent = document.querySelector(".article__wrapper");
  if (!blogContent) return;

  blogContent.querySelectorAll("a[href*='/products/']").forEach(link => {
    const productUrl = new URL(link.href, window.location.origin);
    const handle = productUrl.pathname.split("/").pop();

    const cartContainer = document.createElement("span");
    cartContainer.classList.add("auto-add-to-cart");
    link.insertAdjacentElement("afterend", cartContainer);

    fetch(`/products/${handle}.json`)
      .then(response => response.json())
      .then(data => {
        const product = data.product;
        const variants = product.variants;
        const firstVariant = variants[0];
        const hasMultiple = variants.length > 1;

        const cartHtml = `
        <span class="recipe-product">
          <span class="product-options">
            ${hasMultiple ? `
              <select id="variant-select-${handle}" class="variant-dropdown">
                ${variants.map(v => `
                  <option value="${v.id}">
                    ${v.title} - $${(v.price / 1).toFixed(2)}
                  </option>`).join('')}
              </select>
            ` : `<span class="product-price">$${(firstVariant.price / 1).toFixed(2)}</span>`}
            <button class="add-to-cart-btn" data-handle="${handle}" data-variant-id="${firstVariant.id}">
              Add to Cart
            </button>
          </span>
          <span class="cart-confirmation" id="cart-confirmation-${handle}" style="display:none;">
            ✅ Added! <a href="/cart">View Cart</a>
          </span>
        </span>`;

        cartContainer.innerHTML = cartHtml;

        cartContainer.querySelector(".add-to-cart-btn").addEventListener("click", function () {
          const variantId = hasMultiple
            ? cartContainer.querySelector(`#variant-select-${handle}`).value
            : firstVariant.id;

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(() => {
              const msg = document.getElementById(`cart-confirmation-${handle}`);
              msg.style.display = "inline-block";
              setTimeout(() => { msg.style.display = "none"; }, 3000);
            })
            .catch(err => console.error("Cart error:", err));
        });
      })
      .catch(err => console.error("Product fetch error:", err));
  });
});
